export interface ValidationFieldError {
  propertyName: string;
  errorMessage: string;
  errorCode?: string;
}

export interface ApiErrorResponse {
  key: string;
  message: string;
  traceId?: string;
  additionalInformation?: ValidationFieldError[] | null;
}

export interface ValidationApiErrorResponse extends ApiErrorResponse {
  additionalInformation: ValidationFieldError[];
}

export interface ErrorNotification {
  type: 'error' | 'warning' | 'info';
  title: string;
  message: string;
  details?: string[];
  actionable?: boolean;
  action?: {
    label: string;
    callback: () => void;
  };
}

export interface ErrorContext {
  operation: string;
  entityType?: string;
  entityId?: string | number;
  userId?: string;
  timestamp?: Date;
}

export interface ErrorHandlingResult {
  handled: boolean;
  notification?: ErrorNotification;
  shouldRetry?: boolean;
  fallbackAction?: () => void;
}

export interface ToastAction {
  label: string;
  action: () => void;
}

export enum ErrorSeverity {
  CRITICAL = 'critical',
  WARNING = 'warning',
  INFO = 'info',
  TRANSIENT = 'transient',
}

export interface ErrorNotificationStrategy {
  severity: ErrorSeverity;
  displayType: 'dialog' | 'toast' | 'inline' | 'none';
  duration?: number;
  actions?: ToastAction[];
  autoRetry?: boolean;
}
